import CompanyProfile from "../../components/companyProfile/CompanyProfile"

function CompanyProfilePage() {
    return (
        <>
        <CompanyProfile/>
        </>
    )
}
export default CompanyProfilePage